import React, { useEffect, useRef, useState } from "react";
import { Button, IconButton, Skeleton, Switch } from "@mui/material";
import { HiPlus } from "react-icons/hi";
import SearchBar from "screens/leads/components/InputGrid";
import { MdOutlineEdit } from "react-icons/md";
import { SelectComponent } from "screens/perfilAutonomo/components/SelectComponent";
import { toast } from "react-toastify";
import { RevendaComponentProps } from "screens/revenda/utils";
import * as S from "./style";
import { FooterTableEmpreendimentosRevenda } from "../FooterTable";
import { NovoEmpreendimentoModal } from "./novoEmpreendimentoModal/novoEmpreendimentoModal.component";
import { postEmpreendimentoRevendaListar } from "./api/postEmpreendimentoListar";
import { putEmpreendimentoRevendaStatus } from "./api/putEmpreendimentoStatus";

export const EmpreendimentoRevendaComponent: React.FC<
  RevendaComponentProps
> = ({ authToken }) => {
  const [filters, setFilters] = useState({
    nome: "",
    status: true,
  });
  const [empreendimentoModal, setEmpreendimentoModal] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalItensRetorno, setTotalItensRetorno] = useState(10);
  const [countTotalPagination, setCountTotalPagination] = useState(1);
  const [paginationFlag, setPaginationFlag] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [edit, setEdit] = useState<any>(null);

  const didRun = useRef(false);

  useEffect(() => {
    if (!didRun.current) {
      didRun.current = true;
      fetchEmpreendimentos({});
    }
  }, []);

  useEffect(() => {
    if (paginationFlag) {
      setPaginationFlag(false);
      fetchEmpreendimentos({ newPagination: { paginaAtual } });
    }
  }, [paginaAtual, totalItensRetorno]);

  const fetchEmpreendimentos = ({
    newFilters,
    newPagination,
  }: {
    newFilters?: typeof filters;
    newPagination?: {
      paginaAtual?: number;
      totalItensRetorno?: number;
    };
  }) => {
    setLoading(true);
    setPaginationFlag(false);

    postEmpreendimentoRevendaListar({
      ...(newFilters || filters),
      pagina: newPagination?.paginaAtual || paginaAtual,
      registros: newPagination?.totalItensRetorno || totalItensRetorno,
      authToken,
    })
      .then(({ success, data, notifications }) => {
        if (success) {
          setData(data?.data);
          setCountTotalPagination(
            Math.ceil((data?.totalRegistros || 0) / data?.registros)
          );
        } else {
          setData([]);
          setCountTotalPagination(1);
          throw new Error(notifications?.[0]?.message ?? "");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          error?.message
            ? `${error?.message}`
            : "Erro ao buscar empreendimentos"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleStatusChange = (val: boolean) => {
    setFilters((prev) => {
      const d = { ...prev, status: val };
      fetchEmpreendimentos({
        newFilters: d,
        newPagination: { paginaAtual: 1 },
      });
      setPaginaAtual(1);
      return d;
    });
  };

  const handleSearch = () => {
    if (paginaAtual !== 1) {
      setPaginationFlag(true);
      setPaginaAtual(1);
    } else {
      fetchEmpreendimentos({
        newPagination: { paginaAtual: 1 },
      });
    }
  };

  const handleToggleStatus = (id: string, status: boolean) => {
    putEmpreendimentoRevendaStatus({
      id,
      status,
      authToken,
    })
      .then(({ success, notifications }) => {
        if (success) {
          toast.success("Status alterado com sucesso");
          fetchEmpreendimentos({});
        } else throw new Error(notifications?.[0]?.message ?? "");
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          error?.message ? `${error?.message}` : "Erro ao alterar status"
        );
      });
  };

  const handleEdit = (item: any) => {
    setEdit(item);
    setEmpreendimentoModal(true);
  };

  return (
    <S.Container>
      <S.Header>
        <div className="group">
          <div style={{ width: 360 }}>
            <SearchBar
              value={filters.nome}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, nome: e.target.value }))
              }
              handleBtnSearch={handleSearch}
              variant="outlined"
              style={{ width: 360 }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: 300,
            }}
          >
            <p>Status</p>
            <SelectComponent
              data={[
                { value: true, label: "Ativo" },
                { value: false, label: "Inativo" },
              ]}
              onChange={handleStatusChange}
              value={filters.status}
              renderLabel
            />
          </div>
        </div>

        <Button
          style={{
            background: "#2D5BFF",
            color: "#FFFFFF",
            height: 36,
            borderRadius: 8,
            boxShadow: "none",
            textTransform: "none",
          }}
          variant="contained"
          onClick={() => setEmpreendimentoModal(true)}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <HiPlus size={16} />
            {"Novo Empreendimento"}
          </div>
        </Button>
      </S.Header>

      <S.Table>
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
              <Skeleton
                key={item}
                variant="rectangular"
                height={38}
                width="100%"
              />
            ))}
          </div>
        ) : (
          <S.Content>
            <S.TableContainer>
              <S.TableBody>
                <S.TableHeader>
                  <p>{"Empreendimento"}</p>
                  <p>{"Código"}</p>
                  <p>{"Endereço"}</p>
                  <p>{"Ativo"}</p>
                  <p style={{ textAlign: "center" }}>{"Editar"}</p>
                </S.TableHeader>

                <S.TableContent>
                  {data?.length === 0 ? (
                    <p style={{ textAlign: "center", padding: 20 }}>
                      {"Nenhum empreendimento encontrado"}
                    </p>
                  ) : (
                    data?.map((item, index) => (
                      <S.TableItem
                        key={item?.id}
                        first={index === 0}
                        background={index % 2 === 0 ? "#fbfcff" : "white"}
                      >
                        <p>{item?.nome ?? "--"}</p>
                        <p>
                          {item?.idNumerico ? String(item?.idNumerico) : "--"}
                        </p>
                        <p>{`${item?.logradouro ?? ""}, ${
                          item?.numero ?? ""
                        }, ${item?.bairro ?? ""} - ${item?.cidade ?? ""} - ${
                          item?.cep ?? ""
                        }`}</p>
                        <Switch
                          checked={item?.status}
                          onChange={() => {
                            handleToggleStatus(item?.id, !item?.status);
                          }}
                          color="primary"
                          size="small"
                        />
                        <IconButton
                          onClick={() => {
                            handleEdit(item);
                          }}
                          disableRipple
                          sx={{ padding: 0 }}
                        >
                          <MdOutlineEdit size={22} color="#2196F3" />
                        </IconButton>
                      </S.TableItem>
                    ))
                  )}
                </S.TableContent>
              </S.TableBody>
            </S.TableContainer>
          </S.Content>
        )}

        <FooterTableEmpreendimentosRevenda
          onData={({ PaginaAtual, TotalItensRetorno }) => {
            if (PaginaAtual !== paginaAtual) {
              setPaginationFlag(true);
              setPaginaAtual(PaginaAtual || 1);
            }
            if (TotalItensRetorno !== totalItensRetorno) {
              setPaginationFlag(true);
              setTotalItensRetorno(TotalItensRetorno || 10);
            }
          }}
          PaginaAtual={paginaAtual}
          TotalItensRetorno={totalItensRetorno}
          countTotalPagination={countTotalPagination}
        />
      </S.Table>
      {/* miscellaneous */}
      <NovoEmpreendimentoModal
        open={empreendimentoModal}
        edit={edit}
        refetch={() => fetchEmpreendimentos({})}
        authToken={authToken}
        onClose={() => {
          setEmpreendimentoModal(false);
          setEdit(null);
        }}
      />
    </S.Container>
  );
};
